var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('table',{staticClass:"table table-hover",attrs:{"id":'sample_3',"width":"100%"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }